<!-- email-investment-issue.component.html -->
<nz-modal [(nzVisible)]="isVisible"
  [nzTitle]="'Email '+ (transactionType == TransactionsType.Investment ? 'Investment' : 'Expense') +  ' Issue'"
  (nzOnCancel)="handleCancel()" [nzFooter]="footerTpl" nzCentered nzWidth="60%" nzClassName="emailModal">
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="_fS.emailForm" class="emailForm">
      <!-- From Field -->
      <nz-form-item>
        <nz-form-control [nzErrorTip]="fromError">
          <label class="label-text required">From</label>
          <input [disabled]="true" class="input-group" nz-input formControlName="from"
            [placeholder]="transactionType == TransactionsType.Investment ? 'Accounts Receivable (ar@paybev.us)' : 'Accounts Payable (ap@paybev.us)'" />
          <ng-template #fromError let-control>
            <ng-container *ngIf="control.hasError('required')">Please enter the sender's email</ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <!-- To Field -->
      <nz-form-item>
        <nz-form-control [nzErrorTip]="toError">
          <label class="label-text required">To</label>
          <input class="input-group" nz-input formControlName="to" placeholder="Cody Henson (cody@paybev.com)" />
          <ng-template #toError let-control>
            <ng-container *ngIf="control.hasError('required')">Please enter the recipient's email</ng-container>
            <ng-container *ngIf="control.hasError('pattern')">Please enter valid recipient's email</ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <!-- Cc Field -->
      <nz-form-item>
        <nz-form-control>
          <label class="label-text">Cc</label>
          <input class="input-group" nz-input formControlName="cc" placeholder="Cc"
            placeholder="abc@paybev.com, xyz@paybev.com" />
        </nz-form-control>
      </nz-form-item>

      <!-- Subject Field -->
      <nz-form-item>
        <nz-form-control [nzErrorTip]="subjectError">
          <label class="label-text required">Subject</label>
          <input class="input-group" nz-input formControlName="subject"
            [placeholder]=" transactionType == TransactionsType.Investment ? 'Investment ' : 'Expense ' + 'Issue | Pernod Ricard'" />
          <ng-template #subjectError let-control>
            <ng-container *ngIf="control.hasError('required')">Please enter the subject</ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <div nz-row>
        <div nz-col nzSpan="14">
          <!-- Body Field -->
          <nz-skeleton *ngIf="isLoadingData" [nzParagraph]="{ rows: 10 }"></nz-skeleton>
          <nz-form-item *ngIf="!isLoadingData">
            <nz-form-control [nzErrorTip]="bodyError">
              <label class="label-text required">Body</label>
              <angular-editor formControlName="body" [config]="editorConfig"
                (blur)="checkImageUploaded()"></angular-editor>
              <!-- <textarea class="input-group" nz-input formControlName="body" rows="4" placeholder="Your assistance is needed with the request below."></textarea> -->
              <ng-template #bodyError let-control>
                <ng-container *ngIf="control.hasError('required')">Please enter the body</ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="10">
          <div class="ml-1 mt-1" *ngIf="emailDetails">
            <div class="info-container">
              <div class="info-item">
                <span class="info-label">Submitted:</span>
                <span class="info-value">{{emailDetails.submittedDate}}</span>
              </div>
              <div class="info-item">
                <span class="info-label">User:</span>
                <span class="info-value">{{emailDetails.user}}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Site:</span>
                <span class="info-value ellipsis-text" nz-tooltip
                  [nzTooltipTitle]="emailDetails.site?.length > 15 ? emailDetails.site : ''">{{emailDetails.site}}</span>
              </div>
              <div class="info-item" *ngIf="transactionType == TransactionsType.Investment">
                <span class="info-label">Supplier:</span>
                <span class="info-value ellipsis-text" nz-tooltip
                  [nzTooltipTitle]="emailDetails.supplier?.length > 15 ? emailDetails.supplier : ''">{{emailDetails.supplier}}</span>
              </div>
              <div class="info-item" *ngIf="transactionType != 1">
                <span class="info-label">Vendor:</span>
                <span class="info-value ellipsis-text" nz-tooltip
                  [nzTooltipTitle]="emailDetails.vendor?.length > 15 ? emailDetails.vendor : ''">{{emailDetails.vendor}}</span>
              </div>
              <div class="info-item" *ngIf="transactionType == TransactionsType.Investment">
                <span class="info-label">Rep:</span>
                <span class="info-value">{{emailDetails.rep}}</span>
              </div>
              <div class="info-item" *ngIf="transactionType == TransactionsType.Investment">
                <span class="info-label">Email:</span>
                <span class="info-value ellipsis-text" nz-tooltip
                  [nzTooltipTitle]="emailDetails.repEmail?.length > 10 ? emailDetails.repEmail : ''">{{emailDetails.repEmail
                  ? emailDetails.repEmail : '-'}}</span>
              </div>
              <div class="info-item" *ngIf="transactionType != 1">
                <span class="info-label">Email:</span>
                <span class="info-value ellipsis-text" nz-tooltip
                  [nzTooltipTitle]="emailDetails.vendorEmail?.length > 10 ? emailDetails.vendorEmail : ''">{{emailDetails.vendorEmail
                  ? emailDetails.vendorEmail : '-'}}</span>
              </div>
            </div>
            <hr class="separator">
            <div class="balance-container">
              <nz-form-item>
                <nz-form-control class="switch-box">
                  <span
                    [ngClass]="_fS.emailForm.get('includeInMail').value ==true ? 'font-light': 'font-bold active' ">OFF
                  </span>
                  <nz-switch class="switch-margin" formControlName="includeInMail">
                  </nz-switch><span
                    [ngClass]="_fS.emailForm.get('includeInMail').value != true ? 'font-light': 'font-bold vis-green active' ">
                    ON </span>
                  <!-- <nz-switch formControlName="includeInMail"></nz-switch>
                  <label class="switch-label black mr-1">Active</label> -->
                </nz-form-control>
              </nz-form-item>
              <div class="balance-item">
                <span class="balance-label">Available Balance:</span>
                <span class="balance-value">{{emailDetails.availableBalanceValue}}</span>
              </div>
              <div class="balance-item">
                <span class="balance-label">Current Balance:</span>
                <span class="balance-value">{{emailDetails.currentBalanceValue}}</span>
              </div>
              <div class="balance-item">
                <span class="balance-label">Outstanding Balance:</span>
                <span class="balance-value">{{emailDetails.outstandingBalanceValue}}</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </form>
  </ng-container>
  <ng-template #footerTpl>
    <div class="d-flex justify-content-end">
      <div class="d-flex">
        <button nz-button nzType="default" (click)="handleCancel()" class="default-btn width-100">Cancel</button>
        <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isSendingEmail"
          class="medium-btn small-btn width-100 mr-1">Send</button>
      </div>

    </div>
  </ng-template>
</nz-modal>